import { ChartConfig } from "@/components/ui/Chart";
import { i18n } from "@/i18n";

export const defaultChartConfig = {
  current: {
    label: i18n.t("chart.line.current"),
    color: "var(--chart-2)",
  },
  comparison: {
    label: i18n.t("chart.line.previousYear"),
    color: "var(--chart-1)",
  },
} satisfies ChartConfig;

export const chartMargins = {
  left: 0,
  right: 12,
  top: 4,
} as const;

export const defaultYAxisConfig = {
  tickLine: false,
  axisLine: false,
  tickMargin: 2,
  hide: false,
  width: 50,
} as const;

export const defaultXAxisConfig = {
  tickLine: false,
  axisLine: false,
  padding: { right: 8 },
  tickMargin: 8,
  tick: { fontSize: 12 },
} as const;

export const lineConfig = {
  current: {
    strokeWidth: 2,
    dot: false,
    connectNulls: false,
  },
  comparison: {
    strokeWidth: 2,
    connectNulls: false,
    strokeDasharray: "6 4",
    dot: false,
  },
} as const;
